module.exports = __webpack_public_path__ + "img/try.db7c37a9.png";